import React from 'react';
import {
  Typography,
  Box,
  Grid,
  useTheme,
} from '@mui/material';
import { PageLayout } from '../../components/footer/PageLayout';
import { ContentSection } from '../../components/footer/ContentSection';
import { ContactForm } from '../../components/footer/ContactForm';

export const ContactPage: React.FC = () => {
  const theme = useTheme();

  const contactInfo = [
    {
      title: "General Inquiries",
      email: "info@careva.ai",
      phone: "(555) 123-4567",
    },
    {
      title: "Support",
      email: "support@careva.ai",
      phone: "(555) 123-4568",
    },
    {
      title: "Press",
      email: "press@careva.ai",
      phone: "(555) 123-4569",
    },
  ];

  const handleSubmit = async (data: any) => {
    // Handle form submission
    console.log('Form submitted:', data);
  };

  return (
    <PageLayout
      title="Contact Us"
      subtitle="Get in touch with our team. We're here to help and answer any questions you may have."
      breadcrumbs={[
        { label: "Company", href: "/company" },
        { label: "Contact Us" },
      ]}
    >
      {/* Contact Information */}
      <ContentSection
        title="Get in Touch"
        subtitle="Choose the best way to reach us based on your needs."
        backgroundColor={theme.palette.grey[50]}
      >
        <Grid container spacing={4}>
          {contactInfo.map((info, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Box sx={{ textAlign: 'center' }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 'bold',
                    mb: 2,
                    color: theme.palette.primary.main,
                  }}
                >
                  {info.title}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <strong>Email:</strong>{' '}
                  <a
                    href={`mailto:${info.email}`}
                    style={{
                      color: theme.palette.primary.main,
                      textDecoration: 'none',
                    }}
                  >
                    {info.email}
                  </a>
                </Typography>
                <Typography variant="body1">
                  <strong>Phone:</strong>{' '}
                  <a
                    href={`tel:${info.phone.replace(/[^0-9]/g, '')}`}
                    style={{
                      color: theme.palette.primary.main,
                      textDecoration: 'none',
                    }}
                  >
                    {info.phone}
                  </a>
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </ContentSection>

      {/* Contact Form */}
      <ContentSection
        title="Send Us a Message"
        subtitle="Fill out the form below and we'll get back to you as soon as possible."
      >
        <ContactForm onSubmit={handleSubmit} />
      </ContentSection>
    </PageLayout>
  );
};
